import { render } from "./MarinadeForm.vue?vue&type=template&id=a16252e4&scoped=true"
import script from "./MarinadeForm.vue?vue&type=script&lang=js"
export * from "./MarinadeForm.vue?vue&type=script&lang=js"

import "./MarinadeForm.vue?vue&type=style&index=0&id=a16252e4&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16252e4"],['__file',"resources/js/components/MarinadeForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a16252e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a16252e4', __exports__)) {
    api.reload('a16252e4', __exports__)
  }
  
  module.hot.accept("./MarinadeForm.vue?vue&type=template&id=a16252e4&scoped=true", () => {
    api.rerender('a16252e4', render)
  })

}


export default __exports__